import styled from 'styled-components'

export const AdminSignInButton = styled.a`
    margin-left: 35px;
    padding: 7.5px;
    border: none;
    background-color: transparent;
    color: rgba(255, 255, 255, 0.5);
`
